export const MAX_IMG_SIZE = 10;
export const UOMPrefixes = [
  "USD", "EUR", "GBP", "JPY", "INR",
  "CNY", "AUD", "CAD", "SGD", "CHF", "$", "€", "£", "¥", "₹",
  "¥", "A$", "C$", "S$", "CHF"

];
